module.exports = __webpack_public_path__ + "static/media/gallery6.4ed2c1c2.jpg";